import React from "react";
import { STATUSES, statusIndex } from "@/lib/constants";
import { Check, Circle, Loader2 } from "lucide-react";

export default function StatusStepper({ status }) {
  const current = statusIndex(status);
  return (
    <div className="space-y-0" data-testid="status-stepper">
      {STATUSES.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={s} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 ${
                  done
                    ? "bg-brand border-brand text-white"
                    : active
                    ? "bg-white border-brand text-brand"
                    : "bg-white border-slate-200 text-slate-300"
                }`}
              >
                {done ? (
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                ) : active ? (
                  <Loader2 className="h-3 w-3 animate-spin" />
                ) : (
                  <Circle className="h-2 w-2 fill-current" />
                )}
              </div>
              {i < STATUSES.length - 1 && (
                <div className={`w-0.5 h-5 ${done ? "bg-brand" : "bg-slate-200"}`} />
              )}
            </div>
            <span
              className={`text-sm -mt-0.5 pb-3 ${
                active ? "font-semibold text-ink" : done ? "text-ink-soft" : "text-slate-400"
              }`}
            >
              {s}
            </span>
          </div>
        );
      })}
    </div>
  );
}
